import axios from "axios";

const ENDPOINT_PATH = "http://api.ingesc.net/cbtis/";

export default {
  register(email, password) {
    const user = { email, password };
    return axios.post(ENDPOINT_PATH + "register", user);
  },
  login(email, password) {
    const user = { email, password };
    return axios.post(ENDPOINT_PATH + "login.php", user);
  },
  async logged(email, token) {
    const user = { email, token }
    try {
      const response = await axios.post(ENDPOINT_PATH + "token.php", user)
      if (response.data.status == 200) {
        const user = {
          name: response.data.name,
          email: email,
          token: token,
          level: response.data.level,
          avatar: response.data.avatar
        }
        this.setUserLogged(user)
        return {
          ...user,
          name: response.data.name,
          level: response.data.level,
          avatar: response.data.avatar
        }
      } else {
        this.removeUserLogged()
        return null
      }
    } catch (error) {
      console.log(error)
    }
    return null
  },
  setUserLogged(userLogged) {
    const parsed = JSON.stringify(userLogged)
    localStorage.setItem("userLogged", parsed)
  },
  async getUserLogged() {
    if (localStorage.getItem('userLogged')) {
      try {
        let user = JSON.parse(localStorage.getItem('userLogged'))
        const activeUser = await this.logged(user.email, user.token)
        return activeUser ? activeUser : null
      } catch (e) {
        localStorage.removeItem('userLogged')
      }
    }
    return null
  },
  removeUserLogged() {
    if (localStorage.getItem('userLogged')) {
      localStorage.removeItem('userLogged')
    }
  },
};
